import { Component, EventEmitter, forwardRef, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import {
  EscalasRentabilidadeStore,
  IEscalaRentabilidade
} from 'app/domains/core/settings/grupos-rentabilidade/services/escalas-rentabilidade.store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';

@Component({
  selector: 'sgt-escala-rentabilidade-multi-select',
  templateUrl: './escala-rentabilidade-multi-select.component.html',
  styles: [
    `
      span {
        font-size: 14px;
        font-weight: 600;
      }
    `
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EscalaRentabilidadeMultiSelectComponent),
      multi: true
    }
  ]
})
export class EscalaRentabilidadeMultiSelectComponent
  extends CustomControlValueAccessor<number[]>
  implements OnInit, OnDestroy {

  @Input() idsEscalasRentabilidade: number[] = [];
  @Input() variante: 'filtro' | undefined;
  @Output() idsEscalasRentabilidadeChange = new EventEmitter<number[]>();
  options: IOption[] = [];

  escalaIds: {
    [id: number]: number;
  } = {};

  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Selecione os Grupos',
    singular: 'Grupo',
    plural: 'Grupos',
    hasSearchField: false,
    showFooter: true,
  };

  @Input() settings: Partial<IMultiSelectSettings> = {};

  private destroy$ = new Subject<void>();

  constructor(private escalasStore: EscalasRentabilidadeStore) {
    super();
  }

  ngOnInit(): void {
    this.settings = {
      ...this.defaultSettings,
      ...this.settings,
    };

    this.definirCarregando(true);

    this.escalasStore
      .getEscalas$()
      .pipe(takeUntil(this.destroy$))
      .subscribe((escalas) => {
        this.createOptions(escalas);
        this.definirCarregando(false);
      });
  }

  onFirstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened) {
      this.escalasStore.refresh();
    }
  }

  private createOptions(escalas: IEscalaRentabilidade[]): void {
    this.escalaIds = Object.fromEntries(
      escalas.map((escala) => [escala.id, escala.escalaId])
    );

    this.options = escalas.map((escala) => ({
      id: escala.id,
      label: escala.nome,
      isChecked: this.idsEscalasRentabilidade.includes(escala.id)
    }));
  }

  onFilter(): void {
    this.idsEscalasRentabilidadeChange.emit(this.idsEscalasRentabilidade);
  }

  onSelectionChange(): void {
    this.idsEscalasRentabilidade = this.options
      .filter((option) => option.isChecked)
      .map((option) => option.id);

    this.emitChange(this.idsEscalasRentabilidade);
    this.markAsTouched();
  }

  protected updateValue(value: number[] | null): void {
    this.idsEscalasRentabilidade = Array.isArray(value) ? value : [];
  }

  protected onDisabledStateChange(isDisabled: boolean): void {
    this.settings = { ...this.settings, isDisabled };
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
